import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Módulos terceiros
import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

// Componentes
import { ExibeErrosComponent } from '@app/components/exibe-erros/exibe-erros.component';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { ComunicacaoComponentesService } from '@app/services/comunicacao-componentes.service';
import { CommonModule } from '@angular/common';
import { DropdownMeilisearchComponent } from '@app/components/dropdown-meilisearch/dropdown-meilisearch.component';

// Configuração Módulos
const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'Id',
  optionTextField: 'Descricao',
  placeholder: 'Pesquisar...',
  allowClear: true,
  keepSelectedItems: true,
  noResultsFound: 'Nenhum resultado encontrado'
};

@NgModule({
  declarations: [
    ExibeErrosComponent,
    ModalConfirmarComponent,
    DropdownMeilisearchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PaginationModule.forRoot(),
    ButtonsModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    ModalModule.forRoot(),
    NgxSelectModule.forRoot(CustomSelectOptions)
  ],
  providers: [
    AuthGuard,
    ComunicacaoComponentesService
  ],
  exports: [
    CommonModule,
    FormsModule,
    ExibeErrosComponent,
    PaginationModule,
    ButtonsModule,
    NgxSelectModule,
    TabsModule,
    BsDropdownModule,
    TooltipModule,
    DropdownMeilisearchComponent
  ]
})
export class SharedModule { }
